// PAT cá nhân Mattermost — danh tính PHỤ để đăng bài dưới tên dev thay vì bot @avatar.
//
// Lưu RIÊNG tại <ws>/.mattermost/personal-token.json (chmod 600, gitignored),
// KHÔNG đụng credentials.json (schema A2 LOCKED, 6 field, pack đọc nguyên văn).
// Pack chỉ đọc file này khi script được gọi với `--as-me`; mặc định vẫn là bot.
// Contract CLI↔pack: path + 2 field `{username, patToken}` (+ mattermostUrl để
// pack từ chối PAT của server khác với credentials.json).
import { join } from "node:path";
import { ensureDir, writeJsonAtomic } from "./filesystem-helpers.js";
import { MattermostSetupError } from "./resolve-mattermost-bot-channel-via-api-chain.js";

export const PERSONAL_TOKEN_RELATIVE_PATH = join(".mattermost", "personal-token.json");
const SECRET_FILE_MODE = 0o600; // owner-only.

export interface MattermostPersonalToken {
  mattermostUrl: string;
  username: string;
  patToken: string;
}

// GET /api/v4/users/me bằng PAT → username thật của chủ token. 401/403 → lỗi
// kind "token" (PAT sai/hết hạn, hoặc admin chưa bật Personal Access Tokens).
// Bot token cũng qua được bước này, nên chặn riêng: PAT phải là tài khoản người.
export async function validatePersonalToken(baseUrl: string, token: string): Promise<string> {
  const res = await fetch(`${baseUrl}/api/v4/users/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (res.status === 401 || res.status === 403) {
    throw new MattermostSetupError(
      "PAT không hợp lệ hoặc đã bị thu hồi. Tạo lại ở Profile → Security → Personal Access Tokens " +
        "(không thấy mục này = admin chưa bật PAT cho tài khoản bạn).",
      "token",
    );
  }
  if (!res.ok) {
    throw new MattermostSetupError(`Mattermost trả HTTP ${res.status} khi kiểm tra PAT.`, "other");
  }
  const me = (await res.json()) as { username?: string; is_bot?: boolean };
  if (me.is_bot) {
    throw new MattermostSetupError(
      "Token này thuộc bot, không phải PAT cá nhân. Dùng `avatar comm-connect` (không --personal) cho bot.",
      "token",
    );
  }
  if (!me.username) {
    throw new MattermostSetupError("Mattermost không trả username cho PAT này.", "other");
  }
  return me.username;
}

// Ghi personal-token.json atomically chmod 600. Caller chịu trách nhiệm gitignore
// `.mattermost/` (xem ensureMattermostGitignored ở comm-connect.ts).
export async function persistPersonalToken(
  workspaceRoot: string,
  data: MattermostPersonalToken,
): Promise<string> {
  await ensureDir(join(workspaceRoot, ".mattermost"));
  const path = join(workspaceRoot, PERSONAL_TOKEN_RELATIVE_PATH);
  await writeJsonAtomic(path, data, SECRET_FILE_MODE);
  return path;
}
